import useIPA from '@/auth/jwt/useDevice'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 20,
  pageOptions: [20, 50, 100],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'name', label: 'area', sortable: true },
    { key: 'company_name', label: 'Company' },
    { key: 'partner_name', label: 'Partner' },
    { key: 'project_name', label: 'Project' },
    { key: 'site_name', label: 'Site' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/areas', params }
    useIPA.get(param).then(response => {
      const area = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...area })
      commit('setPagination', pagination)
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/area/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData) {
    return new Promise((resolve, reject) => {
      const rawData = {
        site_id: formData.select_1,
        name: formData.text_1,
        description: formData.text_2,
      }
      const param = { rawData, url: 'internal/master/area', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'data-area' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/area', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, area) {
    state.items = area.rows
    state.totalRows = area.rows.length
    state.options = []
    for (let i = 0; i < area.rows.length; i++) {
      const option = []
      for (const key in area.rows[i]) {
        if (key === 'id') {
          option.value = area.rows[i][key]
        } else if (key === 'name') {
          option.title = area.rows[i][key]
        } else if (key === 'id') {
          option.oid = area.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
